import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureCharts } from './config/chartConfig';
import { initCharts } from './utils/chartInit';

// 初始化图表库
initCharts();

// 应用图表配置
configureCharts();

// // 设置 @ant-design/charts 的渲染模式为canvas
// window.g2plot_container_custom_render_mode = true;
// window.g2plot_container_renderer = 'canvas';

// // 设置G2的渲染模式
// if (typeof window !== 'undefined') {
//   window.G2 = window.G2 || {};
//   window.G2.Global = window.G2.Global || {};
//   window.G2.Global.renderer = 'canvas';
//   window.G2.Global.disableShadow = true;
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 打印环境变量，检查是否正确加载
console.log('环境变量 REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
